import RouteItem from ".";
import BookPrescribed from "../pages/administration/BookPrescribed";
import PageUnderConstruction from "../pages/error-pages/PageUnderConstruction";

export const academicRoutes: RouteItem = {
  key: "router-academics",
  title: "Academics",
  tooltip: "Academics",
  path: "/academics",
  enabled: true,
  component: <PageUnderConstruction />,
  appendDivider: true,
  subRoutesDirection: "horizontal",
  subRoutes: [
    {
      key: "router-jesuit-values",
      title: "Books Prescribed",
      tooltip: "Books Prescribed",
      path: "books-prescribed",
      component: <BookPrescribed />,
      enabled: true,
      appendDivider: true,
    },
  ],
};
